import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import moment from 'moment';
import { Tag, Select, DatePicker, Switch } from 'antd';
import { CheckCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  dashboardOptionAtom,
  dashboardPayloadAtom,
  dashboardSelectedStoreAtom,
  businessAtom
} from '../../../../atoms/Atoms';
import { dateRangePresets } from '../../../utils/utils';

function Header() {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const [dashboardOption, setDashboardOption] = useRecoilState(dashboardOptionAtom);
  const setSelectedStoreId = useSetRecoilState(dashboardSelectedStoreAtom);
  const business = useRecoilValue(businessAtom);
  const [dashboardPayload, setDashboardPayload] = useRecoilState(dashboardPayloadAtom);

  function isValidOptionForDatepicker() {
    return dashboardOption === 0 || dashboardOption === 6 || dashboardOption === 8;
  }

  useEffect(() => {
    setDashboardPayload({
      start: moment().startOf('week').format('YYYY-MM-DD'),
      end: moment().endOf('week').format('YYYY-MM-DD'),
      isLifetime: false,
      load: false
    });
  }, []);

  useEffect(() => {
    if (business) {
      setSelectedStoreId(business.id);
    }
  }, [business]);

  return (
    <PageHeader
      className="mb-4 px-0"
      title={t('store_dashboard')}
      tags={
        <Tag
          color="#2db7f5"
          icon={business ? <CheckCircleOutlined /> : <SyncOutlined spin />}
        >
          {business ? business.name : `${t('loading')}...`}
        </Tag>
      }
      extra={
        <div className="grid ml-8 md:ml-0 md:flex md:space-x-2 space-y-2">
          {isValidOptionForDatepicker() && (
            <div className="grid md:flex space-y-2">
              {!dashboardPayload?.isLifetime && (
                <RangePicker
                  format="YYYY-MM-DD"
                  value={[
                    dayjs(dashboardPayload?.start),
                    dayjs(dashboardPayload?.end)
                  ]}
                  presets={dateRangePresets(t)}
                  onChange={(date, dateString) => {
                    setDashboardPayload({
                      ...dashboardPayload,
                      start: dateString[0],
                      end: dateString[1]
                    });
                  }}
                />
              )}
              <div className="mt-1 mx-auto md:mx-1">
                <span className="mt-2 md:ml-1">{t('show_lifetime')}</span>
                <Switch
                  className="md:ml-1"
                  checked={dashboardPayload?.isLifetime}
                  onChange={(checked) => {
                    setDashboardPayload({
                      ...dashboardPayload,
                      isLifetime: checked
                    });
                  }}
                />
              </div>
            </div>
          )}
          <div className="grid md:flex mx-auto space-y-2 md:space-y-0 md:space-x-2">
            <Select
              value={dashboardOption}
              style={{ width: 160 }}
              onChange={(obj) => setDashboardOption(obj)}
            >
              <Option value={0}>{t('sales')}</Option>
              {/* <Option value={6}>{t('customers')}</Option> */}
              <Option value={4}>{t('trends')}</Option>
              <Option value={7}>{t('prep_inventory')}</Option>
              <Option value={8}>{t('top_products')}</Option>
            </Select>
          </div>
        </div>
      }
    />
  );
}

export default Header;
